import { z } from 'zod';

/** Papéis: `cliente` (app) e a equipe (`analista`, `admin`, `juridico`), que só entra no backoffice. */
export const StaffRole = z.enum(['analista', 'admin', 'juridico']);
export type StaffRole = z.infer<typeof StaffRole>;
export const UserRole = z.enum(['cliente', ...StaffRole.options]);
export type UserRole = z.infer<typeof UserRole>;

/** GET /me: quem está logado. Usado pelo app e pelo backoffice no boot. */
export const MeResponse = z.object({
  user: z.object({
    id: z.string(),
    email: z.string(),
    name: z.string(),
    firstName: z.string(),
    role: UserRole,
    emailVerified: z.boolean(),
    twoFactorEnabled: z.boolean(),
  }),
  session: z.object({ expiresAt: z.string(), passkeyVerified: z.boolean() }),
  passkeys: z.number().int(),
});
export type MeResponse = z.infer<typeof MeResponse>;
